import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = ["for"]
const _hoisted_2 = ["id", "value"]
const _hoisted_3 = {
  disabled: "",
  value: ""
}
const _hoisted_4 = ["value"]


export default /*#__PURE__*/_defineComponent({
  __name: 'SelectField',
  props: {
    label: null,
    id: null,
    placeholder: null,
    modelValue: null,
    param: null,
    selectClasses: null,
    options: null,
    className: null
  },
  emits: ['update:modelValue'],
  setup(__props: any) {





return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["text-left", __props.className])
  }, [
    _createElementVNode("label", {
      for: __props.id,
      class: "block mb-1.5 text-xs font-semibold",
      style: {"color":"#4b5563"}
    }, _toDisplayString(__props.label), 9, _hoisted_1),
    _createElementVNode("select", {
      id: __props.id,
      class: "w-full px-4 py-2.5 text-sm rounded-xl focus:outline-none focus:ring-2 focus:ring-[#6CC551]/30 focus:border-[#6CC551] transition-colors",
      style: {"background":"#fff","border":"1px solid #e5e7eb","color":"#111827"},
      value: __props.modelValue,
      onChange: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('update:modelValue', ($event.target as HTMLSelectElement).value)))
    }, [
      _createElementVNode("option", _hoisted_3, _toDisplayString(__props.placeholder), 1),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.options, (option) => {
        return (_openBlock(), _createElementBlock("option", {
          value: option.id,
          key: option.id
        }, _toDisplayString(option[__props.param]), 9, _hoisted_4))
      }), 128))
    ], 40, _hoisted_2)
  ], 2))
}
}

})